export const API_BASE = process.env.VUE_APP_API_BASE || "/api/admin";

export function apiOrigin() {
  return API_BASE.replace(/\/api\/admin\/?$/, "");
}
